
import { HierarchyTrail } from '../../search/schemas'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { categorySvg } from '~/utility/categorySvg'
import { isGlamping } from '~/utility/glamping'
import { CampsiteCategory } from '~~/utility/types/CampsiteCategory'
import { getCampsiteCategoriesPresenter } from '../presenter-json/CampsiteCategoriesUpdaterJson'

@Component
export default class BrowseAllCategories extends Vue {
  @Prop({ required: false })
    currentHierarchy?: HierarchyTrail

  @Prop({ default: () => [] })
    selectedCategoryIds: Array<string>

  categorySvg = categorySvg

  get currentHierarchyName() {
    return this.currentHierarchy?.name || ''
  }

  get currentHierarchyPath() {
    return this.currentHierarchy?.path || ''
  }

  get categoriesFilteredList(): CampsiteCategory[] {
    const categoriesPresenter = getCampsiteCategoriesPresenter(
      this.$route.params.lang || 'en-gb',
    )
    return categoriesPresenter.list.filter(
      (category) => category.id.toString() != '13',
    )
  }

  get categories() {
    return isGlamping(this.selectedCategoryIds)
      ? this.categoriesFilteredList
      : [
        ...this.categoriesFilteredList.filter(
          (cat) => !this.selectedCategoryIds.includes(cat.id),
        ),
        {
          breadcrumbName: '',
          id: 'glamping',
          isByo: false,
          name: 'Glamping',
          order: 0,
          pretty_name: '',
          rootSlug: 'glamping',
          slug: 'glamping',
        },
      ]
  }
}
